(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  //   document.addEventListener('DOMContentLoaded', function() {
  //   const logo = document.querySelector(".footer-large-logo");
  //   const footer = document.querySelector("footer");

  //   if (!logo || !footer) return;

  //   let lastScrollPosition = window.scrollY;
  //   let scale = 1.;
  //   let opacity = 1;

  //   window.addEventListener("scroll", () => {
  //     const currentScrollPosition = window.scrollY;
  //     if (currentScrollPosition < lastScrollPosition) {
  //       scale = Math.max(0.5, scale - 0.01);
  //       opacity = Math.max(0.5, opacity - 0.01);

  //     } else {
  //       scale = Math.min(1, scale + 0.02);
  //       opacity = Math.min(1, opacity + 0.02);
  //     }
  //     logo.style.transform = `scale(${scale})`;
  //     logo.style.opacity = opacity;
  //     logo.style.transition = "transform 0.1s ease, opacity 0.1s ease";
  //     lastScrollPosition = currentScrollPosition;
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
class NewsletterModal extends HTMLElement {
  constructor() {
    super();
    this.newsletterModal = null;
    this.closeButton = null;
    this.focusableElements = [];
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.previouslyFocusedElement = null;
    this.subscriptionForm = null;
  }

  connectedCallback() {
    this.initModal();
  }

  initModal() {
    this.newsletterModal = this.querySelector("#newsletter_model");
    this.closeButton = this.querySelector("#newsletter_model .btn-close");
    this.subscriptionForm = this.newsletterModal?.querySelector('form[action*="contact"]') || 
                           this.newsletterModal?.querySelector('form[action*="newsletter"]') ||
                           this.newsletterModal?.querySelector('form');

    if (!this.newsletterModal) return;

    const isThemeEditor = window.Shopify && window.Shopify.designMode;
    const delay = parseInt(this.newsletterModal.dataset.delay || "0", 10);
    const expiryDays = parseInt(this.newsletterModal.dataset.expiry || "30", 10);
    const hasSubscribed = this.getCookie("newsletter_subscribed");
    const closedAfterSubscription = this.getCookie("newsletter_closed_after_subscription");

const shopId = this.newsletterModal.dataset.shopId;
const ageVerified = sessionStorage.getItem(`verified_${shopId}`) === '1';

const ageVerification = document.getElementById('ageVerificationModal');

if (ageVerification && !ageVerified) {
  return;
}
    
    if (hasSubscribed && !closedAfterSubscription) {
      setTimeout(() => this.showModal(), delay);
    } else if (!hasSubscribed && !isThemeEditor && this.getCookie("newsletter_closed")) {
      return;
    } else if (!hasSubscribed && !isThemeEditor) {
      setTimeout(() => this.showModal(), delay);
    }

    this.initEventListeners(expiryDays);
    this.initSubscriptionListener();
  }

  initSubscriptionListener() {
    if (!this.subscriptionForm) return;
    this.subscriptionForm.addEventListener("submit", (e) => {
      setTimeout(() => {
        this.handleSubscriptionSuccess();
      }, 500);
    });
    document.addEventListener("newsletter:subscribed", () => {
      this.handleSubscriptionSuccess();
    });

    if (window.Shopify && this.subscriptionForm) {
      this.subscriptionForm.addEventListener("shopify:form:success", () => {
        this.handleSubscriptionSuccess();
      });
    }
  }

  handleSubscriptionSuccess() {
    this.setCookie("newsletter_subscribed", "true", 365);
    this.deleteCookie("newsletter_closed");
    this.deleteCookie("newsletter_closed_after_subscription");
    this.hideModal();
    setTimeout(() => {
      this.showModal();
    }, 1000);
  }

  initEventListeners(expiryDays) {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.handleClose(expiryDays);
      });
    }

    document.addEventListener("click", (event) => {
      const ageVerification = document.querySelector('#ageVerificationModal');
        if (
          ageVerification &&
          (
            ageVerification.classList.contains('show') ||
            !ageVerification.classList.contains('d-none')
          )
        ) {
          return;
        }
        if (
          this.newsletterModal.classList.contains("d-flex") &&
          !event.target.closest(".popup-modal") &&
          !event.target.classList.contains("trigger")
        ) {
          this.handleClose(expiryDays);
        }
      });

    this.newsletterModal.addEventListener("keydown", (e) => {
      this.trapFocus(e);
      this.handleEscKey(e, expiryDays);
    });
  }

  handleClose(expiryDays) {
    this.hideModal();
  
    const hasSubscribed = this.getCookie("newsletter_subscribed");
    
    if (hasSubscribed) {
      this.setCookie("newsletter_closed_after_subscription", "true", expiryDays);
    } else {
      this.setCookie("newsletter_closed", "true", expiryDays);
    }
  }

  showModal() {
    this.newsletterModal.classList.remove("d-none");
    this.newsletterModal.classList.add("d-flex");
    this.newsletterModal.setAttribute("tabindex", "-1");
    this.newsletterModal.setAttribute("role", "dialog");
    this.newsletterModal.setAttribute("aria-modal", "true");
    this.previouslyFocusedElement = document.activeElement;
    
    this.waitUntilVisible(() => {
      this.focusableElements = Array.from(
        this.newsletterModal.querySelectorAll(
          'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(el => !el.disabled && el.offsetParent !== null);
      
      this.firstFocusable = this.focusableElements[0];
      this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
      
      const emailInput = this.newsletterModal.querySelector('input[type="email"]');
      if (emailInput) {
        this.safeFocus(emailInput);
      } else if (this.firstFocusable) {
        this.safeFocus(this.firstFocusable);
      } else {
        this.safeFocus(this.newsletterModal);
      }
      
      document.body.style.overflow = "hidden";
    });
  }

  hideModal() {
    if (this.newsletterModal) {
      this.newsletterModal.classList.remove("d-flex");
      this.newsletterModal.classList.add("d-none");
      this.newsletterModal.style.setProperty("display", "none", "important");
    }

    const popupModal = this.querySelector(".popup-modal");
    if (popupModal) popupModal.style.setProperty("display", "none", "important");

    document.body.style.overflow = "";

    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus({ preventScroll: true });
    }
  }

  trapFocus(e) {
    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusable) {
        e.preventDefault();
        this.lastFocusable?.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusable) {
        e.preventDefault();
        this.firstFocusable?.focus();
      }
    }
  }

  handleEscKey(e, expiryDays) {
    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      this.handleClose(expiryDays);
    }
  }

  safeFocus(el) {
    let attempts = 0;
    const tryFocus = () => {
      if (this.isVisible(el)) {
        el.focus({ preventScroll: true });
      } else if (attempts < 20) {
        attempts++;
        requestAnimationFrame(tryFocus);
      }
    };
    tryFocus();
  }

  waitUntilVisible(callback) {
    let tries = 0;
    const check = () => {
      if (this.isVisible(this.newsletterModal)) {
        callback();
      } else if (tries < 20) {
        tries++;
        requestAnimationFrame(check);
      }
    };
    check();
  }

  isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
  }

  getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  deleteCookie(name) {
    document.cookie = `${name}=; expires=${new Date(Date.now() - 1000).toUTCString()}; path=/;`;
  }
}

customElements.define("newsletter-modal", NewsletterModal);

document.addEventListener("DOMContentLoaded", () => {
  const newsletterModalElement = document.querySelector("newsletter-modal");
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
   (function() {
  'use strict';

  const quickOrderForms = document.querySelectorAll('[data-quick-order-form]');

  function updateRowAvailability(row, available, form) {
    row.dataset.quickOrderRowAvailable = String(available);
    const checkbox = row.querySelector('[data-quick-order-checkbox]');
    const qtyInputs = row.querySelectorAll('[data-quick-order-quantity]');

    qtyInputs.forEach((input) => {
      input.disabled = !available;
      if (!available) input.value = '1';
      if (available) {
          const max = getMaxQuantity(input);

          if (max !== Infinity && max > 0) {
            input.max = max;
          } else {
            input.removeAttribute('max');
          }
        } else {
          input.removeAttribute('max');
        }
    });

    if (checkbox) {
      checkbox.disabled = !available;
      if (!available) checkbox.checked = false;
    }

    const availabilityEl = row.querySelector('[data-quick-order-availability]');
    if (availabilityEl) {
      availabilityEl.textContent = available ? 'In stock' : 'Out of stock';
      availabilityEl.classList.toggle('quick-order__availability--in', available);
      availabilityEl.classList.toggle('quick-order__availability--out', !available);
    }

    if (form) updateSubmitButton(form);
  }


  function updateSummary(form) {
    const summary = form.querySelector('[data-quick-order-summary]');
    if (!summary) return;

    let totalProducts = 0;
    let totalQty = 0;

    form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
      const checkbox = row.querySelector('[data-quick-order-checkbox]');
      const qtyInput = getQuantityInput(row);
      if (!checkbox?.checked || !qtyInput) return;
      totalProducts++;
      totalQty += parseInt(qtyInput.value, 10) || 0;
    });

    const newText = `${totalProducts} ${totalProducts === 1 ? 'product' : 'products'} selected (${totalQty} qty)`;
    if (summary.textContent !== newText) summary.textContent = newText;
  }

  function updateSubmitButton(form) {
  const submitBtn = form.querySelector('[data-quick-order-submit]');
  if (!submitBtn) return;
  const anyChecked = [...form.querySelectorAll('[data-quick-order-checkbox]')]
    .some(cb => cb.checked);
  submitBtn.disabled = !anyChecked;
  }

  function getQuantityInput(row) {
    // Prefer the visible (non-hidden) input; fall back to the first one
    const inputs = row.querySelectorAll('[data-quick-order-quantity]');
    for (const input of inputs) {
      if (input.offsetParent !== null) return input; // visible
    }
    return inputs[0] || null;
  }

  function syncQuantityInputs(row, value) {
    row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
      input.value = value;
    });
  }
 function getMaxQuantity(input) {
  const managed = input.dataset.inventoryManaged;
  const policy = input.dataset.inventoryPolicy;
  const qty = parseInt(input.dataset.inventoryQuantity, 10) || 0;

  if (!managed) return Infinity;

  if (policy === 'continue') return Infinity;

  // Deny + no inventory
  if (qty <= 0) return 1;

  return qty;
}

function showQtyError(input, message = '') {
  const container = input.closest('.quick-order-card__quantity');
  if (!container) return;

  const error = container.querySelector('[data-quick-order-error]');
  if (!error) return;

  const text = error.querySelector('.quick-order__quantity-error-text');

  if (message) {
    error.hidden = false;
    text.textContent = message;
  } else {
    error.hidden = true;
    text.textContent = '';
  }
}

  function attachVariantChangeHandlers(form) {
    form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
      const select = row.querySelector('[data-quick-order-variant-select]');
      if (!select) return;

      const priceCell = row.querySelector('[data-quick-order-price]');

      select.addEventListener('change', () => {
        const selectedOption = select.options[select.selectedIndex];
        const variantId = selectedOption.value;
        const available = selectedOption.dataset.available === 'true';

        // Update variant ID on ALL quantity inputs in this row
       const quantity = selectedOption.dataset.quantity;
        const policy = selectedOption.dataset.policy;
        const managed = selectedOption.dataset.managed;

        row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {

          input.dataset.quickOrderVariantId = variantId;
          input.dataset.inventoryQuantity = quantity;
          input.dataset.inventoryPolicy = policy;
          input.dataset.inventoryManaged = managed;

          if (managed && policy === 'deny' && Number(quantity) > 0) {
              input.max = quantity;
          } else {
              input.removeAttribute('max');
          }

          input.value = 1;
        });

        row.querySelectorAll('[data-quick-order-error]').forEach(error => {
          error.hidden = true;
          error.textContent = '';
      });

        updateRowAvailability(row, available, form);

        if (priceCell && selectedOption.dataset.price) {
          const priceEl = priceCell.querySelector('.quick-order__price');
          if (priceEl) priceEl.textContent = selectedOption.dataset.price;
        }

        updateSummary(form);
      });
    });
  }

  function initQuantityButtons(form) {
    form.querySelectorAll('.quantity').forEach((wrapper) => {
      const input = wrapper.querySelector('.quick-order__quantity-input');
      const incrementBtn = wrapper.querySelector('.increment-btn');
      const decrementBtn = wrapper.querySelector('.decrement-btn');
      if (!input) return;

      function handleQuantityChange(amount) {
        if (input.disabled) return;
        let value = parseInt(input.value, 10) || 1;
        const max = getMaxQuantity(input);

        if (amount > 0 && value >= max) {
            showQtyError(
              input,
              `Only ${max} item${max > 1 ? 's are' : ' is'} available.`
            );
            return;
          }

        showQtyError(input, '');
        if (amount > 0 && !isNaN(max) && value >= max) return;
        if (amount < 0 && value <= 1) return;
        value += amount;

        const row = input.closest('[data-quick-order-row]');
        if (row) {
          syncQuantityInputs(row, value);
        } else {
          input.value = value;
        }

        input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      incrementBtn?.addEventListener('click', (e) => { e.preventDefault(); handleQuantityChange(1); });
      decrementBtn?.addEventListener('click', (e) => { e.preventDefault(); handleQuantityChange(-1); });

      incrementBtn?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleQuantityChange(1); }
      });
      decrementBtn?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleQuantityChange(-1); }
      });

      [incrementBtn, decrementBtn].forEach((btn) => {
        if (!btn) return;
        btn.setAttribute('role', 'button');
        btn.setAttribute('tabindex', '0');
        if (!btn.getAttribute('aria-label')) {
          btn.setAttribute('aria-label', btn.classList.contains('increment-btn') ? 'Increase quantity' : 'Decrease quantity');
        }
      });
    });
  }

  function initializeForms() {
    document.querySelectorAll('[data-quick-order-form]').forEach((form) => {
      const submitButton = form.querySelector('[data-quick-order-submit]');
      const submitDefaultLabel = form.dataset.quickOrderSubmitLabel || submitButton?.textContent || 'Add selected to cart';
      const emptyMessage = form.dataset.quickOrderEmptyMessage || 'Set a quantity above zero before adding to cart.';
      const genericErrorMessage = form.dataset.quickOrderGenericErrorMessage || 'Something went wrong while adding to cart.';

      // Checkbox listeners
      form.querySelectorAll('[data-quick-order-checkbox]').forEach((checkbox) => {
        checkbox.addEventListener('change', () => updateSummary(form));
      });

      // Quantity input listeners (debounced)
      let summaryTimeoutId;
      form.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.addEventListener('input', () => {
          clearTimeout(summaryTimeoutId);
          summaryTimeoutId = setTimeout(() => updateSummary(form), 150);
        });
      });

      attachVariantChangeHandlers(form);

      // *** Clone to remove any old submit listeners, THEN init buttons on the clone ***
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);

      // Re-attach checkbox + quantity listeners on the new form
      newForm.querySelectorAll('[data-quick-order-checkbox]').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          updateSummary(newForm);
          updateSubmitButton(newForm);
        });
      });

      let summaryTimeoutId2;
     newForm.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {

          input.addEventListener('input', () => {

            let value = parseInt(input.value, 10) || 1;
            const max = getMaxQuantity(input);

            if (value < 1) value = 1;

            if (value > max) {
              value = max;

              showQtyError(
                  input,
                  `Only ${max} item${max > 1 ? 's are' : ' is'} available.`
                );
            } else {
              showQtyError(input, '');
            }

            input.value = value;

            const row = input.closest('[data-quick-order-row]');
            syncQuantityInputs(row, value);

            clearTimeout(summaryTimeoutId2);
            summaryTimeoutId2 = setTimeout(() => updateSummary(newForm), 150);

          });

        });

      attachVariantChangeHandlers(newForm);

      // *** Init quantity buttons on the CLONED form ***
      initQuantityButtons(newForm);

      setTimeout(() => {
          updateSummary(newForm);
          updateSubmitButton(newForm);
        }, 100);

      newForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        const submitBtn = newForm.querySelector('[data-quick-order-submit]');
        const statusEl = newForm.querySelector('[data-quick-order-status]');
        if (!submitBtn || !statusEl) return;

        const items = [];
        const rowsToHighlight = [];

        newForm.querySelectorAll('[data-quick-order-row]').forEach((row) => {
          const checkbox = row.querySelector('[data-quick-order-checkbox]');
          const qtyInput = getQuantityInput(row);
          if (!checkbox?.checked || !qtyInput || qtyInput.disabled) return;

          const quantity = parseInt(qtyInput.value, 10) || 1;
          const variantId = Number(qtyInput.dataset.quickOrderVariantId);
          if (!variantId) return;

          items.push({ id: variantId, quantity });
          rowsToHighlight.push(row);
        });

        if (items.length === 0) {
          setStatus(statusEl, emptyMessage);

          setTimeout(() => {
            setStatus(statusEl);
          }, 3000); 

          return;
        }

        submitBtn.disabled = true;
        setStatus(statusEl);

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) {
            let errorMessage = genericErrorMessage;
            try {
              const errorData = await response.json();
              if (errorData?.description || errorData?.message) {
                errorMessage = errorData.description || errorData.message;
              }
            } catch (_) {}
            setStatus(statusEl, errorMessage);
            setTimeout(() => {
           setStatus(statusEl);
          }, 3000); 
            return;
          }

          rowsToHighlight.forEach((row) => {
            row.classList.remove('quick-order__row--added');
            void row.offsetWidth;
            row.classList.add('quick-order__row--added');
            syncQuantityInputs(row, 1);
            const checkbox = row.querySelector('[data-quick-order-checkbox]');
            if (checkbox) checkbox.checked = false;
          });
          updateSubmitButton(newForm);

          updateSummary(newForm);
          setTimeout(() => {
           setStatus(statusEl);
          }, 3000); 
          document.dispatchEvent(new CustomEvent('quick-order:items-added', { detail: { items } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          const cartType = newForm.dataset.cartType;
          if (cartType === 'drawer') {
            const cartDrawer = document.getElementById('cartOffCanvas');
            if (cartDrawer && window.bootstrap?.Offcanvas) {
              const instance = bootstrap.Offcanvas.getInstance(cartDrawer) || new bootstrap.Offcanvas(cartDrawer);
              instance.show();
            }
          } else {
            window.location.href = '/cart';
          }

        } catch (_) {
         setStatus(statusEl, genericErrorMessage);
          setTimeout(() => {
           setStatus(statusEl);
          }, 3000); 
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = submitDefaultLabel;
        }
      });
    });
  }

  initializeForms();

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const form = event.target?.querySelector('[data-quick-order-form]');
      if (form) setTimeout(() => updateSummary(form), 200);
    });
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(() => {
        document.querySelectorAll('[data-quick-order-form]').forEach((form) => updateSummary(form));
      }, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      document.querySelectorAll('[data-quick-order-form]').forEach((form) => updateSummary(form));
    }, 100);
  });

  window.addEventListener('load', () => {
    setTimeout(() => {
      document.querySelectorAll('[data-quick-order-form]').forEach((form) => updateSummary(form));
    }, 100);
  });
})();

function setStatus(statusEl, message = '') {
  const text = statusEl.querySelector('.quick-order__status-text');
  if (!text) return;

  if (message) {
    text.textContent = message;
    statusEl.classList.remove('d-none');
  } else {
    text.textContent = '';
    statusEl.classList.add('d-none');
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
function initWdtIcon(){
  let wdtIconItem = document.querySelectorAll('.text-with-icon-item');

  wdtIconItem.forEach(wdtItem => {
    let wdtItem_height = wdtItem.clientHeight / 2;
    let wdtItem_parent = wdtItem.closest('.section-text-with-icon');
    wdtItem_parent.setAttribute('style', `--before-top: ${wdtItem_height}px;`);
  });
}
  initWdtIcon();

  } catch(e) { console.error(e); }
})();
})();
